import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ShareArrow = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.56 9.197v7.414c0 .852-.68 1.528-1.504 1.539-10.609.138-20.565 4.69-23.617 14.927 7.476-6.517 15.59-8.74 23.948-6.804.694.16 1.174.786 1.174 1.493v7.063L41.724 22.23 27.56 9.197Zm-2.023-1.158c0-1.333 1.564-2.034 2.538-1.136L43.503 21.1c.67.616.661 1.686-.019 2.29L28.056 37.115c-.98.872-2.519.167-2.519-1.154v-7.78c-7.938-1.705-15.697.644-22.991 7.552a1.503 1.503 0 0 1-2.51-1.412C2.707 21.74 14.08 16.405 25.536 16.111V8.04Z"
  }));
});
ShareArrow.displayName = 'ShareArrow';
ShareArrow.defaultProps = {
  'aria-label': 'ShareArrow'
};
export default ShareArrow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ShareArrow.js
// module id = 3911
// module chunks = 11